// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cb_Ky","top":"styles_top__2nl4V"};